export default "__VITE_ASSET__DJsGjTUv__"